import api from '@/app/api';
import {create} from 'zustand';
import { SearchQuery } from './interface/searchFlightInterface';

// Cache for storing recent search results
const searchCache = new Map();
const CACHE_EXPIRY_TIME = 5 * 60 * 1000; // 5 minutes

const useHotelBookingStore = create((set) => ({
  hotelSearchSuggestions: [], 
  hotelSearchResult: [],
  session:{},
  getDetail:{},
  isLoading:false,
  isHotelSearchSuggestionsLoading:false,
  isHotelSearchLoading:false,
  isSessionLoading:false,
  error: null,
  receiveError:false,
  bookingRequest:{},
  requestUrl:'/',
  isErrors:false,
  nationalities: [],
  isNationalitiesLoading: false,
  cancellationCharges: {},
  isCancellationChargesLoading: false,

  searchHotelSuggestion: async (value:string) => {
    // Don't search if value is too short
    if (!value || value.length < 2) {
      set({ isHotelSearchSuggestionsLoading: false, hotelSearchSuggestions: [] });
      return [];
    }

    // Check cache first
    const cacheKey = `hotel_suggestion_${value.toLowerCase()}`;
    const cachedResult = searchCache.get(cacheKey);
    if (cachedResult) {
      set({ isHotelSearchSuggestionsLoading: false, hotelSearchSuggestions: cachedResult });
      return cachedResult;
    }

    set({ isHotelSearchSuggestionsLoading: true }); // Set loading state
    try {
      const response = await api.get(`/search/hotelSuggestions?value=${encodeURIComponent(value)}`);
      if (!response?.data) {
        throw new Error('Network response was not ok');
      }
      const data = response.data;
      
      // Cache the result
      searchCache.set(cacheKey, data);
      setTimeout(() => searchCache.delete(cacheKey), CACHE_EXPIRY_TIME);
      
      set({ isHotelSearchSuggestionsLoading: false, hotelSearchSuggestions: data });
      return data;
    } catch (error:any) {
      set({isHotelSearchSuggestionsLoading: false, error: error});
      return [];
    }
  },
  setHotelsSearch: async (data:SearchQuery)=>{
    set({ isHotelSearchLoading: true, error: null }); // Set loading state
    try {
      set({ hotelSearchResult:data , isHotelSearchLoading: false, error: null });
    } catch (error:any) {
      set({ error: error, isHotelSearchLoading: false }); // Handle errors
    }
  },

  getHotelDetail: async (id:number)=>{
    set({ isLoading: true, error: null }); // Set loading state
    try {
      const response :any= await api.post(`/search/hotel/details` , id); // Fetch users from an AP
      set({ getDetail:response.data,isLoading: false, error: null });
      return response
    } catch (error:any) {
      set({ error: error, isLoading: false }); // Handle errors
    }
  },
  updateHotelDetailSearch: async (data:any)=>{
    set({ isLoading: true, error: null }); // Set loading state
    try {
      const response :any= await api.post(`/search/hotel/details` , data); // Fetch users from an API
      set({ getDetail:response.data,isLoading: false, error: null });
      return response
    } catch (error:any) {
      set({ error: error, isLoading: false }); // Handle errors
    }
  },
//   getFareRule: async (data:any)=>{
//     set({ isLoading: true, error: null }); // Set loading state
//     try {
//       const response :any= await api.post(`/flight/farerule` , data); // Fetch users from an API
//       set({ fareRule:response.data.data.fareRule,isLoading: false, error: null });
//       return response
//     } catch (error:any) {
//       set({ error: error, isLoading: false }); // Handle errors
//     }
//   },
  createSession: async (data:string[])=>{
   
    set({ receiveError:false ,isSessionLoading: true, error: null }); // Set loading state
    try {
      const response:any = await api.post(`/hotel/session` , data); // Fetch users from an API

      set({ session:response.data.session,isSessionLoading: false, error: null,receiveError:false });
      return response
    } catch (error:any) {
      set({ receiveError:true ,error: error, isSessionLoading: false }); // Handle errors
    }
  },

  setIsLoading : (isLoading:boolean) => {
    set({ isLoading: isLoading });
  },
 
  setRequestUrl:()=> (url:string)=>{
    set({requestUrl:url})
  },
  setSessionExpired:()=>(isExpired:boolean)=>{
    set({isSessionExpired:isExpired})
  },
  getCancellationCharges: async (id: number) => {
    set({ isCancellationChargesLoading: true });
    try {
      const response = await api.get(`/hotel/cancellation/charges/${id}`);
      set({ cancellationCharges: response.data, isCancellationChargesLoading: false });
      return response.data;
    } catch (error: any) {
      set({ isCancellationChargesLoading: false, error: error });
    }
  },
  cancelHotelBooking: async (bookingId: string) => {
    set({ isLoading: true, error: null });
    try {
      const response = await api.post(`/hotel/booking/cancel` , {booking_id:bookingId});
      set({ isLoading: false, error: null });
      return response.data;
    } catch (error: any) {
      set({ 
        error: error.response?.data?.message || 'Failed to cancel booking', 
        isLoading: false 
      });
      throw error;
    }
  },
  setIsError:(isError:boolean)=>{
    set({isErrors:isError})
  },

  setSearchNationalities: async (nationalities: any) => {
    set({ isNationalitiesLoading: true });
    try {
      const response = await api.get(`/search/hotel/nationality?value=${nationalities}`); // Fetch users from an API
      if (!response?.data) {
        throw new Error('Network response was not ok');
      }
      const data = response.data;
      set({ isNationalitiesLoading: false, nationalities: data });
      return data;
    } catch (error: any) {
      set({ isNationalitiesLoading: false, error: error });
    }
  },
}));

export default useHotelBookingStore;
